import { useCallback, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import Board from '../../../components/Board';
import BoardName from '../../../components/BoardName';
import { useParams } from 'react-router-dom';
import { RESIZE } from '../../../redux/actions/board';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import './style.css';
import { getBoardFromContract } from '../../../util/metamask';
import Billboard from '../../../components/Billboard';
import Snackbar from '@mui/material/Snackbar';
import { useSnackbar } from 'notistack';
import Page from '../../../components/Page';
import CircularProgress from '@mui/material/CircularProgress';


const View = () => {

    const dispatch = useDispatch(),
    { enqueueSnackbar } = useSnackbar(),
    [ board, setBoard ] = useState( null ),
    [ infoOpen, setInfoOpen ] = useState( true ),
    labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    [ loading, setLoading ] = useState( false ),
    locale = useSelector( state => state.app.locale ),
    { id } = useParams();

    /**
     * @name closeInfo
     * @function
     * @description Dismisses the info dialog
     */
    const closeInfo = () => {
        setInfoOpen( false );
    }

    /**
     * @name dispatchResize
     * @function
     * @description Alerts the app to change the magnification sizes
     */
    const dispatchResize = useCallback(() => {
        dispatch({ type: RESIZE });
    }, [ dispatch ]);

    const getBoard = useCallback( async () => {
        setLoading( true );
        try{
            const gottenBoard = await getBoardFromContract( id );
            setBoard( gottenBoard );
        } catch( err ){
            console.error( err.message );
            enqueueSnackbar(
                "Error: " + err.message,
                { variant: 'error' }
            );
        }
        setLoading( false );
    }, [ enqueueSnackbar, id, setBoard, setLoading ]);

    useEffect(() => {
        getBoard();
    }, [ id, getBoard ]);

    // let the app know what we're dealing with
    useEffect(() => {
        dispatch({ type: RESIZE });
        window.addEventListener( 'resize', dispatchResize, true );
        return () => {
            window.removeEventListener( 'resize', dispatchResize, true );
        }
    }, [ dispatch, dispatchResize ]);

     // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        board && !loading ?
            <>
                <BoardName disabled source={{ name: board.name, revision: board.revision, fork: board.fork }} />
                <Board disabled source={ board } />
                <Snackbar className="coe__view__snackbar" open={ infoOpen } anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
                    <Alert severity='info' onClose={ closeInfo }>
                        <AlertTitle>{ labels.alertTitle }</AlertTitle>
                        <div className="coe__view__snackbar__copy">
                           { labels.alertBody }
                        </div>
                    </Alert>
                </Snackbar>
            </> :
            <Page modifier="view">
                {
                    loading ?
                        <div className='coe__view__loading'>
                            <CircularProgress size={ 100 } />
                        </div> :
                        <Billboard 
                            alignItems="center" 
                            title={ labels.title } 
                            body={ labels.body } 
                            Icon={ DashboardIcon } />
                }
            </Page>
    )

}

export default View